import React from 'react';
import styled from 'styled-components';
import { Wrapper, CenteredWrapper } from '../shared/commonStyles';
import Title from '../title/Title';
import Description from '../text/Description';
import ProductCard from '../card/ProductCard';
import Button from '../button/Button';

import Image1 from '../../assets/image/life_style_item/original_tea.png'
import Image2 from '../../assets/image/life_style_item/original_item.png'
import Image3 from '../../assets/image/life_style_item/marriage_certificate.png'

const CollaborationDressWrapper = styled.section`
  
`;

const SectionLifeStyleItem = () => {
    const text = 'PLACOLE＆DRESSY(プラコレ＆ドレシー)\nその魔法を、お家でも愉しめるよう、\n彩り豊かな紅茶、マカロン、テーブルウェアなど\n様々なアイテムで展開をしております。';
    const url = "https://weddingdress.pla-cole.wedding/"
    const buttonText = '購入ページはこちら'

    const products= [
        {
            title: "オリジナル紅茶「オリジナルドレスアップティー」",
            image: Image1,
            url: "https://weddingdress.pla-cole.wedding/c/dressy-room-and-tea",
        },
        {
            title: "オリジナルアイテム・ギフト",
            image: Image2,
            url: "https://weddingdress.pla-cole.wedding/c/gift",
        },
        {
            title: "婚姻届",
            image: Image3,
            url: "https://weddingdress.pla-cole.wedding/c/marriage-certificate",
        },
    ]

    return (
      <Wrapper id="life-style-item">
        <CollaborationDressWrapper>
            <Title 
                title={"ORIGINAL ITEM"}
                subTitle={"オリジナルアイテム"}    
            />
            <Description text={text} />
            {
                products.map((product, index) => (
                    <ProductCard 
                        key={index}
                        title={product.title}
                        image={product.image}
                        url={product.url}
                        buttonText={buttonText}
                    />
                ))
            }
            <CenteredWrapper>
                <Button 
                    url={url}
                    buttonText={"全アイテムを見る"}
                />
            </CenteredWrapper>
        </CollaborationDressWrapper>
      </Wrapper>
    );
  };
  
export default SectionLifeStyleItem;
  